<template>
  <div id="buying-zone" class="pdp-product-container">
    <section :class="{'h-screen': loading}">
      <div v-if="!loading">
        <pdp-no-product-data v-if="!productData" @tryAgain="loadProductData" />
        <component
          :is="productDetailsComponent"
          v-else
          :product="productData"
          :options="options"
          :base-properties="baseProperties"
          :copy-positioning-statement="copyPositioningStatement"
        />
      </div>
    </section>
  </div>
</template>

<script>
import {ProductApi} from '@/api/product';
import SchemaMarkup from '@/utils/schema-markup';
import PdpB2bProductDetails from '@/components/containers/pdp/b2b/PdpProductDetails';
import PdpB2cProductDetails from '@/components/containers/pdp/b2c/PdpProductDetails';
import PdpNoProductData from '@/components/containers/pdp/PdpNoProductData';
import {filterArchivedProducts} from '@/components/containers/pdp/utils/filter-archived-products';
import {PdlLoading} from '@pedal/pdl-loading';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'PdpBuyingZoneContainer',

  components: {PdpNoProductData, PdlLoading},

  props: {
    copyPositioningStatement: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      productData: null,
    };
  },

  computed: {
    ...mapGetters('backend', ['b2b']),
    productDetailsComponent() {
      return this.b2b ? PdpB2bProductDetails : PdpB2cProductDetails;
    },
  },
  watch: {
    async productData(updatedProductData) {
      if (!updatedProductData || !updatedProductData.powerReviewsID) return;
      this.fetchProductReviews(updatedProductData.powerReviewsID).then((reviewsData) => {
        SchemaMarkup.init()
          .addProductDetails(updatedProductData)
          .addPowerReviews(reviewsData)
          .injectMarkup();
      });
    },
  },

  mounted() {
    this.loadProductData();
  },

  methods: {
    ...mapActions('powerReviews', ['fetchProductReviews']),
    initializeLegacyPdpHandlers() {
      // This method must be refactored.
      const event = new Event('init-pdp');
      window.dispatchEvent(event);
    },

    loadProductData() {
      this.loading = true;

      ProductApi.loadProduct(this.productId)
        .then((data) => {
          this.productData = filterArchivedProducts(data);

          const variantsWithBundle = this.productData.variants.filter(
            (variant) => variant.bundleTemplateIdList?.length > 0
          );

          if (variantsWithBundle.length > 0) {
            const bundleTemplateIdList = [];
            const skusWithBundle = [];
            variantsWithBundle.forEach((variant) => {
              skusWithBundle.push(variant.code);
              bundleTemplateIdList.push(variant.bundleTemplateIdList[0]);
            });

            this.addBundleTemplates({id: bundleTemplateIdList, sku: skusWithBundle});
          }

          this.$nextTick(() => {
            this.initializeLegacyPdpHandlers();
            this.loading = false;
          });
          this.$emit('is-archived', this.productData.isArchived);
        })
        .catch((reason) => {
          console.error(reason.message);
          this.loading = false;
          this.productData = null;
        });
    },

    ...mapActions('productBundle', ['addBundleTemplates']),
  },
};
</script>
